@if (isCollapsed) {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="toggleCollapsed()"
        [id]="'toggleCollapseButton-' + antecedent?.PatientBehaviorAntecedent"
      >
        {{ antecedent?.PatientBehaviorAntecedent }}
      </button>
    </div>

    @if (antecedent?.IsDeleted) {
    <div class="col-2">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
    </div>
    }

    <div class="col-1">
      <i
        class="pi pi-arrow-down pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="toggleCollapsed()"
      ></i>
    </div>
  </div>
</div>
} @else {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="toggleCollapsed()"
        [id]="'toggleCollapseButton-' + antecedent?.PatientBehaviorAntecedent"
      >
        {{ antecedent?.PatientBehaviorAntecedent }}
      </button>
    </div>

    @if (antecedent?.IsDeleted) {
    <div class="col-2">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
    </div>
    }

    <div class="col-1">
      <i
        class="pi pi-arrow-up pointer"
        (click)="toggleCollapsed()"
        style="font-size: 1rem; color: #719eb6"
      ></i>
    </div>
  </div>

  <div class="row" id="antecedentActions">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <button
          (click)="editAntecedent()"
          [id]="'editAntecedentButton-' + antecedent?.PatientBehaviorAntecedent"
          class="side-menu-button2 flex-grow-1 mx-2"
          [disabled]="antecedent?.IsDeleted"
          [style.opacity]="antecedent?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="antecedent?.IsDeleted ? 'not-allowed' : 'pointer'"
        >
          Edit Antecedent
        </button>
        @if (!antecedent?.IsDeleted) {
          <button
          (click)="deleteAntecedent()"
          [id]="'deleteAntecedentButton-' + antecedent?.PatientBehaviorAntecedent"
          class="switch-mode-button flex-grow-1 mx-2"
          [style.opacity]="'1'"
        >
          Delete Antecedent
        </button>
        }
        @else{
          <button
          (click)="restoreAntecedent()"
          [id]="'restoreAntecedentButton-' + antecedent?.PatientBehaviorAntecedent"
          class="side-menu-button2 flex-grow-1 mx-2"
          [style.opacity]="'1'"
          >
            Restore Antecedent
          </button>
        }
      </div>
    </div>
  </div>
</div>
}
